import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import SelectInput from "../../Global Functions/selectInput";
import TextInput from "../../Global Functions/textInput";
import "./SelectCab.css";
import { useDispatch, useSelector } from "react-redux";
import {
  viewCityListCab,
  viewStateList,
} from "../../Redux/Actions/settingsActions";
import { viewCabRequestList } from "../../Redux/Actions/cabRequestActions";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const SelectCab = () => {
   const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const location = useLocation();
  const countryId = location.state?.countryId;
  const serviceProviderId = location.state?.serviceProviderId;

  const dispatch = useDispatch();

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchDetails = (page, limit) => {
    const payload = { page, limit };
    dispatch(viewCabRequestList(payload));
  };

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
  }, []);

  const { cabs } = useSelector((state) => state.cabs || {});
  const availableCabs =
    cabs?.data?.map((c) => ({
      id: c._id,
      name: c.name,
    })) || [];

  const { states } = useSelector((state) => state.states || {});
  const { cities } = useSelector((state) => state.city || {});

  const [selectedCabs, setSelectedCabs] = useState([]); // currently selected cab
  const [formData, setFormData] = useState({}); // current cab form
  const [showCabDropdown, setShowCabDropdown] = useState(false);

  const toggleCabDropdown = () => setShowCabDropdown(!showCabDropdown);

  // Fetch states on load
  useEffect(() => {
    dispatch(
      viewStateList({
        page: 1,
        limit: 1000,
        country: countryId,
      })
    );
  }, [dispatch, countryId]);

  // Fetch cities when a state is selected
  useEffect(() => {
    selectedCabs.forEach((cab) => {
      const selectedStateId = formData[cab.id]?.state;
      if (selectedStateId) {
        dispatch(
          viewCityListCab({
            states: selectedStateId, // backend expects array
          })
        );
      }
    });
  }, [dispatch, formData, selectedCabs]);

  const handleCheckboxChange = (cab) => {
    setSelectedCabs([cab]);
    setFormData({});
  };

  const handleFieldChange = (cabId, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [cabId]: {
        ...prev[cabId],
        [field]: value,
      },
    }));
  };

  const handleCancel = () => {
    setSelectedCabs([]);
    setFormData({});
    setShowCabDropdown(false);
  };

  const handleSave = async () => {
    if (selectedCabs.length === 0)
      return toast.error("Select a cab and fill details before saving");

    const cab = selectedCabs[0];

    const payload = {
      service_provider: serviceProviderId,
      country_id: countryId,
      cab_type: cab.id,
      states: formData[cab.id]?.state?.length ? formData[cab.id].state : [],
      cities: formData[cab.id]?.city || [],
      rate_per_unit: formData[cab.id]?.rate_per_unit || "",
      rate_per_unit_measure_in:
        formData[cab.id]?.rate_per_unit_measure_in || "",
      round_trip_rate_per_unit: formData[cab.id]?.round_trip_rate_per_unit || "",
    };

    try {
      const { data } = await axios.post(
        `${BASE_URL}/cab-service-provider/select-cab`,
        payload
      );
      console.log("✅ Saved Successfully:", data);

      toast.success("Cab selection saved successfully!");

      setSelectedCabs([]);
      setFormData({});
    } catch (error) {
      console.error("❌ Error saving cab selection:", error);
      toast.error("Failed to save cab selection!");
    }
  };

  return (
    <MainLayout>
      <div className="select-cab-container">
        <div className="select-cab-header">
          <h2 className="select-cab-title">Cab Info</h2>
          {/* <button className="view-provider-btn">View Service Provider</button> */}
          <button className="view-provider-btn" onClick={() => navigate("/cabServiceProvider")}>View Service Provider</button>
        </div>

        <div className="input-block">
          <label className="input-label-cab">Cab</label>
          <div className="dropdown-wrapper" onClick={toggleCabDropdown}>
            <div className="dropdown-display">
              Select Cab
              <span className="arrow">{showCabDropdown ? "▲" : "▼"}</span>
            </div>
            {showCabDropdown && (
              <div className="checkbox-group">
                {availableCabs.map((cab, index) => (
                  <label key={index} className="checkbox-item">
                    <input
                      type="checkbox"
                      checked={selectedCabs.some(
                        (selected) => selected.id === cab.id
                      )}
                      onChange={(e) => {
                        e.stopPropagation();
                        handleCheckboxChange(cab);
                      }}
                    />
                    {cab.name}
                  </label>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="cab-cards">
          {selectedCabs.map((cab, index) => (
            <div className="cab-card" key={index}>
              <div className="cab-card-header">
                <h3>{cab.name}</h3>
                <button className="remove-btn" onClick={handleCancel}>
                  &times;
                </button>
              </div>
              <div className="cab-card-grid">
                <TextInput
                  placeholder="Enter Rate per unit"
                  name={`${cab.id}rate_per_unit`}
                  value={formData[cab.id]?.rate_per_unit || ""}
                  onChange={(e) =>
                    handleFieldChange(cab.id, "rate_per_unit", e.target.value)
                  }
                  required
                />
                <TextInput
                  placeholder="Enter Round trip rate per unit "
                  name={`${cab.id}round_trip_rate_per_unit`}
                  value={formData[cab.id]?.round_trip_rate_per_unit || ""}
                  onChange={(e) =>
                    handleFieldChange(cab.id, "round_trip_rate_per_unit", e.target.value)
                  }
                  required
                />
                {/* Single state */}
                <SelectInput
                  placeholder="State"
                  name={`${cab.id}_state`}
                  value={formData[cab.id]?.state || []}
                  options={
                    states?.data?.map((s) => ({
                      label: s.state_name,
                      value: s._id,
                    })) || []
                  }
                  multiSelect={true}
                  onChange={(e) =>
                    handleFieldChange(cab.id, "state", e.target.value)
                  }
                />
                <SelectInput
                  placeholder="Unit"
                  name={`${cab.id}rate_per_unit_measure_in`}
                  value={formData[cab.id]?.rate_per_unit_measure_in || ""}
                  options={[
                    { label: "km", value: "km" },
                    { label: "miles", value: "miles" },
                  ]}
                  onChange={(e) =>
                    handleFieldChange(cab.id, "rate_per_unit_measure_in", e.target.value)
                  }
                />
                {/* Multiple cities */}
                <SelectInput
                  placeholder="City"
                  name={`${cab.id}_city`}
                  value={formData[cab.id]?.city || []} // array
                  options={
                    cities?.data?.map((c) => ({
                      label: c.city_name,
                      value: c._id,
                    })) || []
                  }
                  multiSelect={true}
                  onChange={(e) =>
                    handleFieldChange(cab.id, "city", e.target.value)
                  }
                />
              </div>
            </div>
          ))}
        </div>

        <div className="action-buttons">
          <button onClick={handleCancel} className="cancel-btn">
            Cancel
          </button>
          <button onClick={handleSave} className="save-btn">
            Save
          </button>
        </div>
      </div>
    </MainLayout>
  );
};

export default SelectCab;
